module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/hospital_list/img_hospital05-08f2d3e81bbc9deba2282cea52c32502.png";